const yup = require('yup')
const { requiredFields, labelify } = require('./helpers')
const organizationTagCategories = require('../organization-tag-categories')

const shape = labelify({
  name: yup.string().default(''),
  category: yup.string().oneOf(organizationTagCategories).required(),
  disabled: yup.bool().default(false),
  createdAt: yup.date(),
  updatedAt: yup.date(),
  createdBy: yup.mixed(),
  updatedBy: yup.mixed(),
})

const organizationTagSchemaPartial = yup.object().shape(shape)
const organizationTagSchema = organizationTagSchemaPartial.shape(requiredFields(['name'])(shape))

module.exports = { organizationTagSchema, organizationTagSchemaPartial }
